import { type TCallOrdersFilter } from '@/types/ICallOrdersFilter';

/** Ключ выборки, когда грузить нечего. */
const EMPTY_KEY = 'none';

/**
 * Строит стабильный ключ выборки заказов звонка.
 *
 * Фильтр приходит объектом, поэтому сравнивать его по ссылке нельзя: новый
 * литерал на каждом рендере перезапускал бы загрузку по кругу. Ключ отражает
 * содержимое выборки и служит признаком «выборка сменилась» — по нему
 * сбрасывается страница пагинации.
 *
 * @param filter - выборка заказов либо `null`
 * @returns строковый ключ выборки
 */
export const getCallOrdersFilterKey = (
  filter: TCallOrdersFilter | null
): string => {
  if (filter === null) {
    return EMPTY_KEY;
  }

  return filter.kind === 'client'
    ? `${filter.kind}:${String(filter.clientId)}`
    : `${filter.kind}:${filter.phone}`;
};
